import type { PropsWithChildren } from 'react';

export interface PropertyListItemProps extends PropsWithChildren {}

export function PropertyListItem({ children }: PropertyListItemProps) {
  return <div className="flex justify-between gap-sm">{children}</div>;
}
PropertyListItem.displayName = 'PropertyListItem';
